export const headerData = {
    title: '',
    submodules: [
    ],
}

// function createData(id, moduleName, ref) {
//     return { id, moduleName, ref };
// }